import { render, staticRenderFns } from "./WhatsAppAddProfileDialog.vue?vue&type=template&id=5b70bc8c&scoped=true"
import script from "./WhatsAppAddProfileDialog.vue?vue&type=script&lang=js"
export * from "./WhatsAppAddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppAddProfileDialog.vue?vue&type=style&index=0&id=5b70bc8c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b70bc8c",
  null
  
)

export default component.exports